<template>
  <div>
    <div class="con-tab-ejemplo">
      <div class="vx-row">
        <div class="vx-col w-full vx-coll-fixed-hight">
          <vs-table :data="interestRateDetails">

            <template slot="thead">
              <vs-th>{{ $t('sections.accounting.dataForm.tableInterestRate.no') }}</vs-th>
              <vs-th>{{ $t('sections.accounting.dataForm.tableInterestRate.interestDate') }}</vs-th>
              <vs-th>{{ $t('sections.accounting.dataForm.tableInterestRate.interestRate') }}</vs-th>
              <vs-th>{{ $t('sections.accounting.dataForm.tableInterestRate.penaltyRate') }}</vs-th>
              <vs-th class="w-1/4">การคิดค่าธรรมเนียมการทวงถาม</vs-th>
              <vs-th></vs-th>
            </template>

            <template slot-scope="{data}" >
              <vs-tr :key="index" v-for="(res, index) in data">
                <vs-td :data="(index+1)">
                  {{ (index+1) }}
                </vs-td>
                <vs-td :data="res.interestDate">
                  {{ res.interestDate | convYYYYMMDDToDDMMYYYY}}
                </vs-td>
                <vs-td :data="res.interestRate">
                  {{ res.interestRate | convPerYear }}<br>
                  <vs-chip color="success">{{ res.interestType | interestType}}</vs-chip>
                </vs-td>
                <vs-td align="center">
                  <div class="center-chip">
                    {{ res.interestRate | convPerYear }}<br>
                    <vs-chip color="success">{{ res.interestType | interestType}}</vs-chip>
                  </div>
                </vs-td>
                <vs-td align="center" >
                  <div class="center-chip">
                    {{ res.penaltyRate | convPerYear}}<br>
                    <vs-chip color="success">{{ res.penaltyType | interestType }}</vs-chip>
                  </div>
                </vs-td>
                <vs-td align="center">
                  <div class="center-chip">
                    {{ res.debtCollectionFeeType === IDebtCollectionFeeType.fixed ? interestRateDefault.debtCollectionFeeAmount : '0.00'}}<br>
                    <vs-chip color="primary">{{ res.debtCollectionFeeTypeName }}</vs-chip>
                  </div>
                </vs-td>
              </vs-tr>
            </template>

          </vs-table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import {createNamespacedHelpers} from 'vuex'
import {IDebtCollectionFeeType} from "@/constants/interface";
import {interestRateDefault} from "@/constants/config";
const { mapActions: mapAccountingActions, mapState: mapAccountingState} = createNamespacedHelpers('Accounting');

export default {
  props: ['manage'],
  computed:{
    IDebtCollectionFeeType() {
      return IDebtCollectionFeeType
    },
    interestRateDefault() {
      return interestRateDefault
    },
    ...mapAccountingState([
      'status',
      'contract',
      'interestRateDetails',
    ])
  },
  methods: {
    ...mapAccountingActions([
      'deleteInterestRateDetail'
    ]),
    async delInterestRateDetail (id) {
      const vm = this
      vm.actionID = id
      vm.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: vm.$t('notification.confirm-delete-title'),
        text: vm.$t('notification.confirm-delete-message'),
        accept: vm.acceptDelInterestRateDetail
      })
    },
    async acceptDelInterestRateDetail () {
      await this.deleteInterestRateDetail({
        form: {
          id: this.actionID
        },
        vm: this
      })
    },
    isHideDelInterestRateDetail (res){
      return !(res.seq !== 1 && this.manage);
    },
  },
}
</script>

<style scoped>
  .vx-coll-fixed-hight{
    display:block;
    width:100%;
    height:400px;
    overflow: auto;
  }
  .center-chip {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
  }
</style>
